export const checkNewRelicOnWindow = (): boolean =>
  !!(typeof window !== 'undefined' && (window as any).newrelic)

export const setNewRelicCustomAttribute = (key: string, value: string): void => {
  if (checkNewRelicOnWindow()) {
    ;(window as any).newrelic.setCustomAttribute(key, value)
  }
}

export const setNewRelicPageAction = (key: string, value: object): void => {
  if (checkNewRelicOnWindow()) {
    ;(window as any).newrelic.addPageAction(key, value)
  }
}



// WEBPACK FOOTER //
// ./src/utils/newrelic.ts